import { render, staticRenderFns } from "./JudgerList.vue?vue&type=template&id=049c50e5&scoped=true&"
import script from "./JudgerList.vue?vue&type=script&lang=js&"
export * from "./JudgerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c50e5",
  null
  
)

export default component.exports